<nz-spin nzSize="large" *ngIf="isLoading"></nz-spin>
<ng-content>

</ng-content>
